<div class="brand-block" *ngIf="!isAddClientDetails">
 GENERAL CONFIGURATION
</div>
<div class="brand-block" *ngIf="isAddClientDetails">
  GENERAL CONFIGURATION
</div>
